import { yup } from '@guiker/shared-framework'

import { InquiryQualificationStatus } from '../../../../../entity'

const optionalString = yup.string().optional().nullable()

export const updateQualificationSchema = yup.object({
  qualificationStatus: yup.string().oneOf(Object.values(InquiryQualificationStatus)).required(),
  disqualificationReason: yup.string().when('status', {
    is: InquiryQualificationStatus.DISQUALIFIED,
    then: yup.string().required(),
    otherwise: optionalString.transform(() => undefined),
  }),
  roomCount: optionalString,
  budget: yup.number().optional().nullable(),
  hasPet: yup.boolean().optional().nullable(),
  needsParking: yup.boolean().optional().nullable(),
  moveInDate: optionalString,
  creditScore: optionalString.transform((v) => v || undefined),
  visitSchedule: optionalString.transform((v) => v || undefined),
  contactMethod: optionalString.transform((v) => v || undefined),
})
